<template>
  <div ref="sliderBar" id="app_slide">
    <el-scrollbar style="height: 100%;">
      <el-menu
        mode="vertical"
        unique-opened
        :default-active="$route.path"
        :collapse-transition="false"
        :collapse="state"
        router
        class="el-menu-demo"
        text-color="#666"
        active-text-color="#fff">
        <template v-for="item in adminRoutes"  v-if="!item.hidden">
          <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path" :key="item.children[0].name">
            <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
              <i v-if="item.children[0].meta&&item.children[0].meta.icon" :class="item.children[0].meta.icon"></i>
              <span slot="title" v-if="item.children[0].meta&&item.children[0].meta.title">{{item.children[0].meta.title}}</span>
            </el-menu-item>
          </router-link>

          <el-submenu v-else :index="item.name||item.path" :key="item.name">
            <template slot="title">
              <i v-if="item.meta&&item.meta.icon" :class="item.meta.icon"></i>
              <span v-if="item.meta && item.meta.title && !sliderBarState">{{item.meta.title}}</span>
            </template>

            <template v-for="child in item.children" v-if="!child.hidden">
              <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

              <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
                <el-menu-item :index="item.path+'/'+child.path">
                  <i v-if="child.meta&&child.meta.icon" :class="child.meta.icon"></i>
                  <span v-if="child.meta&&child.meta.title">{{child.meta.title}}</span>
                </el-menu-item>
              </router-link>
            </template>
          </el-submenu>

        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'appSlierBar',
  props: {
    allRoutes: {
      type: Array,
      default () {
        return ['获取路由失败']
      }
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'sliderBarState',
      'adminRoutes'
    ]),
    state () {
      return this.sliderBarState
    }
  },
  methods: {
    hasOneShowingChildren (children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    filterRoutes (children) {
      const showRoutes = children.filter((item) => {
        return !item.hidden
      })
      if (showRoutes.length === 1) {
        return true
      }
      return false
    }
  }
}
</script>
<style scope lang="scss">
@import '../../../../styles/variable.scss';
#app_slide {
  .el-menu:not(.el-menu--collapse) {
    width: 250px;
  }
  background-color: $sliderColor;
  height: 100%;
  .el-menu {
    background-color: $sliderColor;
    border-color: $sliderColor;
    .el-submenu__title:hover {
      background-color: rgba(0, 0, 0, .3);
    }
    .is-active  {
      background-color: $sliderColor;
    }
    .el-menu-item:hover {
      background-color: rgba(0, 0, 0, .3);
    }
  }
  .el-menu--collapse {
    .is-active  {
      background-color: #000;
    }
  }
  .app_scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      height: 100%;
    }
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
    // background-color: $sliderColor ;
    // background-color: lightgray;
  }
  .el-menu-item *, .el-submenu__title * {
    font-weight: bold;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/firmiana/admin/components/adminSliderBar.vue